import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
    key: 3,
    class: "product-attribute-value-icon product-attribute-value-icon--svg"
};
const _hoisted_3 = ["href"];
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAttributeValueIcon',
    props: {
        icon: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.icon.type === 'fontawesome')
                ? (_openBlock(), _createBlock(Icon, {
                    key: 0,
                    name: __props.icon.icon,
                    class: "product-attribute-value-icon"
                }, null, 8, ["name"]))
                : (__props.icon.type === 'css')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(['product-attribute-value-icon', __props.icon.icon])
                    }, null, 2))
                    : (__props.icon.type === 'img')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "product-attribute-value-icon product-attribute-value-icon--img",
                            src: __props.icon.icon,
                            alt: ""
                        }, null, 8, _hoisted_1))
                        : (__props.icon.type === 'svg')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                                _createElementVNode("use", {
                                    href: __props.icon.icon
                                }, null, 8, _hoisted_3)
                            ]))
                            : _createCommentVNode("", true);
        };
    }
});
